import { Component } from '@angular/core';

@Component({
  selector: 'shared-skeletons-cards-ngx-datatable-mobile',
  templateUrl: './skeletons-cards-ngx-datatable-mobile.component.html',
})
export class SkeletonsCardsNgxDatatableMobileComponent {}
